import axios from "axios";

export default function updateRole({ uuid, name, accessRights }) {
  const promise = new Promise((resolve, reject) =>
    axios
      .put(`/account/system-admin/api/v1/admin-role/${uuid}`, {
        name,
        access_rights: accessRights,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );

  return promise;
}
